// src/api/auth.js
import axios from "axios";
import http, { API_BASE_URL } from "./http";

/*
 * skipAuth: true
 * این درخواست‌ها نباید Authorization بفرستند و نباید وارد منطق refresh شوند
 * (وگرنه توکن قدیمی/منقضی روی صفحه‌ی لاگین باعث ۴۰۱ و ریدایرکت می‌شود).
 * پشتیبانی‌اش در http.js اضافه شده است.
 */
const PUBLIC = { skipAuth: true };

export const checkPhone = (phone) => {
  return http.post("/auth/check-phone/", { phone_number: phone }, PUBLIC);
};
// ارسال کد یکبار مصرف
export const sendOtp = (phone) => {
  return http.post("/auth/send-otp/", { phone_number: phone }, PUBLIC);
};

// تایید کد
// کاربر کامل:      { access, refresh }
// کاربر جدید/ناقص: { needs_registration: true, registration_token }
export const verifyOtp = (phone, code) => {
  return http.post(
    "/auth/verify-otp/",
    { phone_number: phone, code: code },
    PUBLIC,
  );
};

// ورود با رمز عبور  →  { access, refresh }
export const loginWithPassword = (phone, password) => {
  return http.post(
    "/auth/login-password/",
    { phone_number: phone, password },
    PUBLIC,
  );
};

// تکمیل ثبت نام  →  { access, refresh }
// payload: { registration_token, password, first_name, last_name }
export const completeRegistration = (payload) => {
  return http.post("/auth/register/complete/", payload, PUBLIC);
};

export const resetPasswordForLogIn = (payload) => {
  const { reset_token, ...data } = payload;
  return axios.post(`${API_BASE_URL}/api/auth/password-reset/confirm`, data, {
    headers: {
      Authorization: `Bearer ${reset_token}`,
      "Content-Type": "application/json",
    },
  });
};
export const resetPassword = (payload) => {
  return http.post(`/auth/password-reset/confirm`, payload);
};

export const verifyResetOtp = (phone, code) => {
  return http.post(
    "/auth/verify-otp/",
    { phone_number: phone, code: code },
    PUBLIC,
  );
};
